import http from "./http";

export type PaymentSurchargeConfig = {
	enabled: boolean;
	type: "percent" | "fixed" | null;
	value: number | null;
	currency: string;
	updatedBy?: number | null;
	updatedAt?: string | null;
};

export async function getPaymentSurchargeAdmin(): Promise<PaymentSurchargeConfig> {
	const { data } = await http.get(`/admin/settings/payment-surcharge`);
	return data;
}

export async function savePaymentSurchargeAdmin(payload: {
	enabled: boolean;
	type?: "percent" | "fixed" | null;
	value?: number | null;
	currency?: string;
}): Promise<PaymentSurchargeConfig> {
	const { data } = await http.put(`/admin/settings/payment-surcharge`, payload);
	return data;
}
